var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 1.28882C5.19682 1.28882 1.2887 5.19694 1.2887 10.0001C1.2887 14.8038 5.1962 18.7113 9.99995 18.7113C14.8037 18.7113 18.7112 14.8038 18.7112 10.0001C18.7112 5.19694 14.8037 1.28882 9.99995 1.28882ZM9.99995 17.4613C5.88557 17.4613 2.5387 14.1138 2.5387 10.0001C2.5387 5.88569 5.88557 2.53882 9.99995 2.53882C14.1137 2.53882 17.4612 5.88569 17.4612 10.0001C17.4612 14.1138 14.1137 17.4613 9.99995 17.4613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.98438C8.49189 4.98438 7.26501 6.20062 7.26501 7.69562C7.26501 8.04062 7.54501 8.32062 7.89001 8.32062C8.23501 8.32062 8.51501 8.04062 8.51501 7.69562C8.51501 6.87625 9.16689 6.23438 10 6.23438C10.8194 6.23438 11.485 6.90562 11.485 7.73125C11.485 8.04312 11.0388 8.48875 10.645 8.8825C10.05 9.47687 9.37501 10.1512 9.37501 11.055V11.9475C9.37501 12.2931 9.65501 12.5725 10 12.5725C10.345 12.5725 10.625 12.2931 10.625 11.9475V11.055C10.625 10.6694 11.0844 10.21 11.5288 9.76625C12.0938 9.20125 12.735 8.56063 12.735 7.73125C12.735 6.21625 11.5081 4.98438 10 4.98438Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 14.7251C9.0625 14.9737 9.16127 15.2122 9.33709 15.388C9.5129 15.5638 9.75136 15.6626 10 15.6626C10.2486 15.6626 10.4871 15.5638 10.6629 15.388C10.8387 15.2122 10.9375 14.9737 10.9375 14.7251C10.9375 14.4765 10.8387 14.238 10.6629 14.0622C10.4871 13.8864 10.2486 13.7876 10 13.7876C9.75136 13.7876 9.5129 13.8864 9.33709 14.0622C9.16127 14.238 9.0625 14.4765 9.0625 14.7251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.24d17fe10e8a5a05c0cf33997d1805e4.svg";
export { ForwardRef as ReactComponent };